import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQuery } from "@/redux/baseQuery";

export interface GetSumsubTokenResponse {
  token: string;
  userId: string;
}

export interface GetSumsubTokenRequest {
  role: "Owner" | "Driver";
}

export const kycApi = createApi({
  reducerPath: "kycApi",
  baseQuery,
  endpoints: (builder) => ({
    getSumsubToken: builder.mutation<GetSumsubTokenResponse, GetSumsubTokenRequest>({
      query: (body) => ({
        url: "/v1/kyc/tokens",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetSumsubTokenMutation } = kycApi;
